module.exports = __webpack_public_path__ + "static/media/azure-data-engineer-associate.3d950dc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/azure-data-engineer-associate.png
// module id = 1374
// module chunks = 0